import _get from 'lodash/get'
import { EMPTY_OBJECT } from 'constants/frozenObjects'

export const getEPSONContacts = state => {
  const res = {}
  state.contacts.contacts.value.forEach(item => {
    res[item.name.toLowerCase()] = {
      email: item.email,
      phoneNumber: item.phoneNumber,
    }
  })

  return res
}

export const getGeneralContact = state => _get(getEPSONContacts(state), 'general', EMPTY_OBJECT)
